/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Unusable_OneInputs */



/**
* | output |
* | --- |
* | "1 report has an unreadable total and is NOT included in the figure above. The invoicing worker leaves it out of its month's invoice — the rest of that month ..." |
*
* @param {Partner_Admin_Billing_Unusable_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_unusable_one = /** @type {((inputs?: Partner_Admin_Billing_Unusable_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Unusable_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei 1 Bericht ist die Gesamtsumme nicht lesbar; er ist im obigen Betrag NICHT enthalten. Der Rechnungslauf lässt ihn aus der Rechnung seines Monats heraus – der übrige Monat wird weiterhin abgerechnet –, sodass dieser Bericht erst abgerechnet wird, wenn seine Daten korrigiert sind.")
	return /** @type {LocalizedString} */ ("1 report has an unreadable total and is NOT included in the figure above. The invoicing worker leaves it out of its month's invoice — the rest of that month still bills — so this report is never invoiced until its data is fixed.")
});